import axiosInstance from './axiosInstance';

/**
 * Profile service — backs the Settings page. The endpoints are mounted
 * twice on the API (under /api/profile/admin and /api/profile/manager)
 * with different JWT verifiers; we pick the right segment based on the
 * caller's role_code in localStorage so the same component works for
 * both dashboards.
 */
const segmentForRole = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const code = user?.role?.role_code || '';
    // Manager + employee accounts log in via the carehome-manager auth
    // (they all share that token verifier), so they use /manager.
    if (code.includes('manager') || code.includes('owner') || code.includes('employee')) return 'manager';
    // admin + staffs come in through the admin token verifier.
    return 'admin';
  } catch (_) {
    return 'admin';
  }
};

const url = (suffix = '') => `/profile/${segmentForRole()}${suffix}`;

const profileService = {
  getMe: async () => {
    const res = await axiosInstance.get(url('/me'));
    return res.data;
  },
  getRoleOptions: async () => {
    const res = await axiosInstance.get(url('/me/role-options'));
    return res.data;
  },
  updateMe: async (payload) => {
    const res = await axiosInstance.patch(url('/me'), payload);
    return res.data;
  },
  changePassword: async ({ current_pin, new_pin }) => {
    const res = await axiosInstance.post(url('/me/password'), { current_pin, new_pin });
    return res.data;
  },
  uploadAvatar: async (file) => {
    const form = new FormData();
    form.append('avatar', file);
    const res = await axiosInstance.post(url('/me/avatar'), form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
};

export default profileService;
